import { render, staticRenderFns } from "./applyJoin.vue?vue&type=template&id=08481071&scoped=true"
import script from "./applyJoin.vue?vue&type=script&lang=js"
export * from "./applyJoin.vue?vue&type=script&lang=js"
import style0 from "./applyJoin.vue?vue&type=style&index=0&id=08481071&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08481071",
  null
  
)

export default component.exports